/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seller_Dashboard_Create_ListingInputs */

const en_seller_dashboard_create_listing = /** @type {(inputs: Seller_Dashboard_Create_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create a Listing`)
};

const es_seller_dashboard_create_listing = /** @type {(inputs: Seller_Dashboard_Create_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear un anuncio`)
};

const fr_seller_dashboard_create_listing = /** @type {(inputs: Seller_Dashboard_Create_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créer une annonce`)
};

const de_seller_dashboard_create_listing = /** @type {(inputs: Seller_Dashboard_Create_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserat erstellen`)
};

const ja_seller_dashboard_create_listing = /** @type {(inputs: Seller_Dashboard_Create_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出品を作成`)
};

const zh_seller_dashboard_create_listing = /** @type {(inputs: Seller_Dashboard_Create_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建商品`)
};

const ar_seller_dashboard_create_listing = /** @type {(inputs: Seller_Dashboard_Create_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إنشاء إعلان`)
};

const id_seller_dashboard_create_listing = /** @type {(inputs: Seller_Dashboard_Create_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buat Listing`)
};

const it_seller_dashboard_create_listing = /** @type {(inputs: Seller_Dashboard_Create_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea un Annuncio`)
};

const ru_seller_dashboard_create_listing = /** @type {(inputs: Seller_Dashboard_Create_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создать объявление`)
};

const pt_seller_dashboard_create_listing = /** @type {(inputs: Seller_Dashboard_Create_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criar um Anúncio`)
};

const ko_seller_dashboard_create_listing = /** @type {(inputs: Seller_Dashboard_Create_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`상품 등록하기`)
};

/**
* | output |
* | --- |
* | "Create a Listing" |
*
* @param {Seller_Dashboard_Create_ListingInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const seller_dashboard_create_listing = /** @type {((inputs?: Seller_Dashboard_Create_ListingInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seller_Dashboard_Create_ListingInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_seller_dashboard_create_listing(inputs)
	if (locale === "es") return es_seller_dashboard_create_listing(inputs)
	if (locale === "fr") return fr_seller_dashboard_create_listing(inputs)
	if (locale === "de") return de_seller_dashboard_create_listing(inputs)
	if (locale === "ja") return ja_seller_dashboard_create_listing(inputs)
	if (locale === "zh") return zh_seller_dashboard_create_listing(inputs)
	if (locale === "ar") return ar_seller_dashboard_create_listing(inputs)
	if (locale === "id") return id_seller_dashboard_create_listing(inputs)
	if (locale === "it") return it_seller_dashboard_create_listing(inputs)
	if (locale === "ru") return ru_seller_dashboard_create_listing(inputs)
	if (locale === "pt") return pt_seller_dashboard_create_listing(inputs)
	return ko_seller_dashboard_create_listing(inputs)
});